/**
 * PURE (2026-10-02): Request-Bodies vor dem Senden bereinigen.
 *
 * Hintergrund: Detail-Antworten des Backends enthalten für jedes Mongoose-Unterdokument
 * (Öffnungszeiten-Slots inkl. start/end, Social Media, Teams …) eine `_id`. Die
 * Bearbeiten-Seiten übernehmen die Objekte in den Formular-State und schicken sie beim
 * Speichern unverändert zurück – das Backend-Schema lehnte `_id` als „unbekanntes Feld“
 * ab (400) und die Seite zeigte nur „Aktualisierung fehlgeschlagen“ (Shop/Verein/Spielstätte
 * mit Zeiten). Das Backend verwirft die _ids inzwischen selbst; hier zusätzlich, damit auch
 * ältere Backend-Stände bedient werden und kein Builder daran denken muss.
 *
 * Entfernt `_id` NUR in verschachtelten Objekten/Arrays – nie auf oberster Ebene (dort
 * nutzen einzelne Endpunkte `_id` als Kennung). Liefert eine Kopie, Eingabe bleibt unverändert.
 */
export const stripNestedMongoIds = <T>(payload: T): T => {
  const strip = (value: unknown, depth: number): unknown => {
    if (Array.isArray(value)) return value.map((item) => strip(item, depth + 1));
    if (value == null || typeof value !== 'object') return value;
    if (value instanceof Date || value instanceof File || value instanceof Blob) return value;
    const out: Record<string, unknown> = {};
    for (const [key, inner] of Object.entries(value as Record<string, unknown>)) {
      if (depth > 0 && key === '_id') continue;
      out[key] = strip(inner, depth + 1);
    }
    return out;
  };
  return strip(payload, 0) as T;
};

export default stripNestedMongoIds;
